import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import { ArrowLeft, Mail, Lock } from 'lucide-react';
import LogoMark from '../components/LogoMark';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const result = await login(formData.email, formData.password);
      if (result.success) {
        toast.success(result.message);
        navigate('/dashboard');
      } else {
        toast.error(result.message || 'Login failed. Please check your credentials.');
      }
    } catch (error) {
      toast.error('Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="brand-theme min-h-screen dot-pattern flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link
          to="/"
          className="inline-flex items-center gap-2 font-bold mb-6 hover:underline decoration-4 underline-offset-4 decoration-[#bcd445]"
        >
          <ArrowLeft size={20} />
          <span>Back to home</span>
        </Link>

        <div className="bg-white border border-ink/10 rounded-lg shadow-saas">
          <div className="bg-cream p-6 border-b border-ink/10 flex items-center gap-3">
            <LogoMark />
            <span className="font-bold text-lg tracking-tight text-ink">GovernWell</span>
          </div>

          <div className="p-8">
            <h1 className="font-bold tracking-tight text-4xl mb-2">Welcome Back</h1>
            <p className="font-medium text-ink/70 mb-8">Sign in to your governance dashboard</p>

            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="space-y-2">
                <label htmlFor="email" className="flex items-center gap-2 font-bold uppercase text-sm tracking-wide">
                  <Mail size={16} />
                  Email Address
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="you@charity.org.uk"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full h-12 px-4 bg-cream border border-ink/10 rounded-lg font-medium focus:outline-none focus:bg-lime/20 placeholder:text-ink/40"
                />
              </div>

              <div className="space-y-2">
                <label htmlFor="password" className="flex items-center gap-2 font-bold uppercase text-sm tracking-wide">
                  <Lock size={16} />
                  Password
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className="w-full h-12 px-4 bg-cream border border-ink/10 rounded-lg font-medium focus:outline-none focus:bg-lime/20 placeholder:text-ink/40"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full h-12 bg-lime border border-ink/10 rounded-lg shadow-saas font-bold text-lg uppercase tracking-wide disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {loading ? 'Signing in...' : 'Sign In'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
